export const CARD_EXPIRATION_DATE_MAX_LENGTH = 5; // MM/YY
export const CARD_EXPIRATION_DATE_REGEX = /^(0[1-9]|1[0-2])\/\d{2}$/;

export const formatCardExpirationDate = (value: string): string => {
  const cleanedValue = value.replace(/\D/g, '');
  const month = cleanedValue.slice(0, 2);
  const year = cleanedValue.slice(2, 4);

  let formattedValue = month;
  if (cleanedValue.length > 2) {
    formattedValue += `/${year}`;
  }

  return formattedValue;
};

export const getCardExpirationMonthIndex = (
  month: number,
  twoDigitYear: number,
): number => (2000 + twoDigitYear) * 12 + month - 1;

export const getCurrentCardExpirationMonthIndex = (): number => {
  const now = new Date();
  return now.getFullYear() * 12 + now.getMonth();
};
